<template>
  <el-container class="height100">
    <el-main class="el-mainContent paddingLeft0 height100 overflowYHidden" ref="managerMain">
      <el-row class="obpm-fromContent-title obpm-enterpriseDomain-logo normalHeight" ref="normalHeight">
        <el-col :span="16" class="normalLineH">{{$t('rolelist')}}</el-col>
        <el-col :span="8" style="text-align:right" class="normalLineH">
          <el-button  size="small" type="primary" plain @click="$emit('exit')">{{$t('back')}}</el-button>
        </el-col>
      </el-row>

      <el-row ref="search">
        <el-col :span="16">
          <el-form :inline="true" :model="searchdata" class="form-inline" size="mini"  @submit.native.prevent>
            <el-form-item >
              <el-input v-model="searchdata.data.name" :placeholder="$t('name')" @keyup.enter.native="searchTableData"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" plain @click="searchTableData">{{$t('query')}}</el-button>
              <el-button @click="resetSearchTableData">{{$t('reset')}}</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="8" class="align-right"></el-col>
      </el-row>

      <!-- 管理员列表 -->
      <el-table 
        stripe
        :data="roles.role"
        ref="multipleTable"
        :row-key="handleReserve" 
        header-cell-class-name="tableHeaderbg"
        size="small"
        :height="tableListConHeight">
        <el-table-column prop="roleName" :label="$t('rolename')"></el-table-column>
        <!-- <el-table-column prop="state" label="状态"></el-table-column> -->
        <!-- <el-table-column prop="email" label="操作"></el-table-column> -->
        <el-table-column :label="$t('operating')">
          <template slot-scope="scope">
            <el-button @click.stop="roleBatchUserBtn(scope.row)" type="primary" plain size="mini" >分配用户</el-button>

          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        ref="pagination"
        @size-change="handleSizeChange"
        @current-change="searchTableData"
        :current-page.sync="searchdata.currpage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="searchdata.pagelines"
        layout="prev, pager, next, total, sizes"
        background
        :total="roles.rowCount?roles.rowCount:0"
        
      ></el-pagination>
    </el-main>
    <roleBatchUser :visible.sync="roleBatchUserVisible" v-if="roleBatchUserVisible" v-bind:roleId='roleIdBatch'/>

  </el-container>
</template>

<script>
import roleBatchUser from "@/components/roleBatchUser.vue";

export default {
  components: { roleBatchUser},
  props:["applicationId"],
  created() {
    this.searchTableData();
  },
  mounted(){
    // var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.tableListConHeight=this.$refs.managerMain.$el.getClientRects()[0].height-this.$refs.normalHeight.$el.getClientRects()[0].height-this.$refs.search.$el.getClientRects()[0].height-this.$refs.pagination.$el.getClientRects()[0].height;
    
  },
  data() {
    return {
      userSelectVisible: false,
      searchdata: {
        applicationid: this.applicationId,
        currpage:1,
        pagelines:10,
        data:{
          name: "",
        }
      },
      roles: [],
      roleId:"",
      multipleTable:[],
      multipleSelection:[],
      selectTimer:'',
      tableListConHeight:null,
      rolePermissionVisible:false,
      isBatch:false,
      roleBatchUserVisible:false,
      roleIdBatch:'',
    };
  },
  computed:{
    
  },
  methods: {
    resetSearchTableData(){
      this.searchdata.data.name='';
      this.searchTableData()
    },
    searchTableData() {
      // name: this.searchdata.name ,currpage:this.searchdata.currpage,pagelines:this.searchdata.pagelines
      this.$api.getRoleList(
        this.searchdata,
        {
          onSucess: resp => {
            this.roles = resp.data.data;
            
          }
        }
      );
    },
    handleReserve(row){
      return row.roleId;
    },
    
    handleSizeChange(size){
      this.searchdata.pagelines=size;
      this.searchTableData();
    },
    roleBatchUserBtn(row){
      this.roleIdBatch=row.roleId;
      this.roleBatchUserVisible=true;
    }
  }
};
</script>

<style>
</style>